// IMPORTANT: Import instrumentation FIRST, before anything else
// This initializes all monitoring providers (Sentry, DataDog, etc.)
// eslint-disable-next-line import/order
import { instrumentation } from './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { analytics } from '@/lib/analytics';

import { App } from './app';
import './index.css';
import './i18n';
import './i18n/types';
import { enableMocking } from './test/mocks';

analytics.initialize();

// Get the combined error handler from all instrumentation providers
const errorHandler = instrumentation.getReactErrorHandler();

void enableMocking().then(() => {
  ReactDOM.createRoot(document.querySelector('#root') as HTMLElement, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: errorHandler,
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: errorHandler,
    // Callback called when React automatically recovers from errors.
    onRecoverableError: errorHandler,
  }).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
